import React, { Component } from 'react';
import cx from 'classnames';
import { injectIntl } from 'react-intl';
import _isObject from 'lodash/isObject';
import _map from 'lodash/map';
import Link from 'components/Link';
import question from 'utils/images/question.svg';
import book from 'utils/images/book_orange.svg';
import { trackDownloadFirmware } from 'utils/analytics';
import AsicIntroCardDownloadList from 'components/asic/AsicIntroCard/AsicIntroCardDownloadList';
import { MODELS_MESSAGES } from 'constants/asicModelsMessages';
import style from './AsicModelCard.module.css';

class AsicModelCard extends Component {
  state = {
    isTipShown: false,
  }

  mouseEnter = () => {
    this.setState({ isTipShown: true });

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  mouseLeave = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.setState({ isTipShown: false });
    }, 700);
  }

  onDownloadButtonClick = () => {
    trackDownloadFirmware();
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    const { props } = this;
    const { isTipShown } = this.state;

    return (
      <div className={style.root}>
        <div className={style.body}>
          <div className={style.title}>
            <div className={style.captions}>
              {(props.improved || props.sdCard) && (
                <>
                  {props.improved && (
                    <div className={style.improvedWrap}>
                      <span className={style.improvedIcon} role="img" aria-label="shield">🛡️</span>
                      <span>Improved</span>
                    </div>
                  )}
                  {props.sdCard && (
                    <div className={style.sdcard}>
                      <span>SD Card</span>
                    </div>
                  )}
                </>
              )}
            </div>
            <div>{props.title}</div>
          </div>
          <div className={style.options}>
            {_map(props.options, (option, i) => {
              if (_isObject(option)) {
                const values = {};
                if (option.hashrate) {
                  values.hashrate = <b key={`${option.intl}-${i}`}>{props.intl.formatMessage({ id: 'AsicModelSwitch.upTo' })}{' '}{option.hashrate}</b>;
                }
                return (
                  <div className={style.option} key={`${option.intl}-${i}`}>
                    <span>{props.intl.formatMessage(MODELS_MESSAGES[option.intl], values)}</span>
                  </div>
                );
              }
              return (
                <div className={style.option} key={`${option}-${i}`}>
                  <span>{props.intl.formatMessage(MODELS_MESSAGES[option])}</span>
                </div>
              );
            })}
          </div>
        </div>
        <div className={style.buttons}>
          {_map(props.buttons, (button, idx) => {
            if (button.type === 'list') {
              return (
                <AsicIntroCardDownloadList
                  key={`${button.title}-${idx}`}
                  items={button.items}
                  title={button.titleIntl}
                />
              )
            } else {
              return (
                <Link
                  external
                  noRef
                  onClick={this.onDownloadButtonClick}
                  href={button.href}
                  className={style.button}
                  key={`${button.title}-${idx}`}
                >
                  <div>{props.intl.formatMessage(MODELS_MESSAGES[button.titleIntl])}</div>
                </Link>
              );
            }
          })}
          {props.buttons && (props.buttons.length === 2) && (
            <div className={style.question}>
              <div className={style.wrap}>
                <img
                  src={question}
                  width="17"
                  height="17"
                  onMouseEnter={this.mouseEnter}
                  onMouseLeave={this.mouseLeave}
                  alt="question icon"
                  role="presentation"
                />
                <div
                  className={cx(style.tip, { [style.isShown]: isTipShown })}
                  onMouseEnter={this.mouseEnter}
                  onMouseLeave={this.mouseLeave}
                  role="presentation"
                >
                  <div className={style.flex}>
                    <div className={style.book}>
                      <img src={book} width="18" height="18" alt="book icon" />
                    </div>
                    {props.intl.formatMessage({ id: "AsicIntroCard.caption1", defaultMessage: "Find out the difference" })}
                  </div>
                  <div className={style.tipBody}>
                    <span>· <a href="https://hiveos.farm/hiveon-asic-firmware-general-standard_improved_firmware#What-is-improved-firmware?" target="_blank" rel="noreferrer">
                      {props.intl.formatMessage({ id: "AsicIntroCard.caption2", defaultMessage: "Improved Firmware" })}
                    </a>
                    </span>
                    <span>· <a href="https://hiveos.farm/hiveon-asic-firmware-general-standard_improved_firmware#What-is-standard-firmware?" target="_blank" rel="noreferrer">
                      {props.intl.formatMessage({ id: "AsicIntroCard.caption3", defaultMessage: "Standard Firmware" })}
                    </a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default injectIntl(AsicModelCard);
